const MealCardLabel = ({ text = '' }) => {
  return <span className={'h7 card__label bg-charcoal-50 text-charcoal-100'}>{text}</span>;
};

MealCardLabel.propTypes = {
  text: PropTypes.string,
};

export default MealCardLabel;
